import { lazy } from 'react';
import {
  organizationsMenuIcon,
  SearchMenuIcon,
  usersMenuIcon
} from '@tools/ui/assets';
import Feedback from '@tools/ui/components/common/Feedback';
import { AppRouter } from '@tools/ui/types';
import { theme } from '@tools/ui-utils/theme.util';
import { APP_PREFIX } from '../consts/route.consts';
import { PATH_FINDER_FEEDBACK_CHANNEL } from '../consts/sharedVariables';
import { userViewRoutes } from './userView.routes';

const UsersView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/user/UsersView'
    )
);

const OrganizationView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/organization/OrganizationTable'
    )
);

const UserViewInvestigationView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/user/UserView'
    )
);

const FindPaymentsView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/components/main/payments/FindPaymentsView'
    )
);

export const pathFinderRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [APP_PREFIX, `${APP_PREFIX}/organizations`]
    },
    {
      name: 'Find Payments',
      path: `${APP_PREFIX}/payments`,
      pages: [],
      component: FindPaymentsView,
      icon: SearchMenuIcon,
      exact: true
    },
    {
      name: 'Find User by Organization',
      path: `${APP_PREFIX}/organizations`,
      pages: [],
      component: OrganizationView,
      icon: organizationsMenuIcon,
      exact: true
    },
    {
      name: 'Find User By Id',
      path: `${APP_PREFIX}/users`,
      pages: [],
      component: UsersView,
      icon: usersMenuIcon,
      exact: true
    },
    {
      name: 'User page',
      path: `${APP_PREFIX}/users/:id`,
      exact: false,
      component: UserViewInvestigationView,
      pages: userViewRoutes,
      hideFromMenu: true,
      backgroundColor: theme.colors.gray.gray40
    }
  ]
};

export const ExtraComponent = () => (
  <Feedback slackChannelId={PATH_FINDER_FEEDBACK_CHANNEL} />
);
